import { computed, ref } from "vue";
import type { MasterTemplate } from "shared-types";

import { META_AD_PREVIEW_TYPE, META_AD_PREVIEW_OPTIONS, type MetaAdPreviewType } from "@/enums/adPreview";

interface MetaAdInputSize {
    adScalingFactor: number;
    width: number;
    height?: number;
    maxHeight?: number;
    minHeight?: number;
}

export function useMetaAdPreview(getMasterTemplate: () => MasterTemplate) {
    const adPreviewType = ref<MetaAdPreviewType>(META_AD_PREVIEW_TYPE.INSTAGRAM_FEED);
    const inStreamVideoIsPlaying = ref(false);

    function setInStreamValue(value: boolean) {
        inStreamVideoIsPlaying.value = value;
    }

    const previewAdInputSize = computed<MetaAdInputSize>(() => {
        const masterTemplate = getMasterTemplate();
        const options = META_AD_PREVIEW_OPTIONS[adPreviewType.value];
        const { inStreamWidth, width, maxHeight, minHeight } = options;

        let height = options.height;
        let adScalingFactor = 1;

        if (inStreamWidth && !inStreamVideoIsPlaying.value && masterTemplate.width > inStreamWidth) {
            adScalingFactor = inStreamWidth / masterTemplate.width;
        } else if (masterTemplate.width > width) {
            adScalingFactor = width / masterTemplate.width;
        }

        switch (adPreviewType.value) {
            case META_AD_PREVIEW_TYPE.INSTAGRAM_FEED:
            case META_AD_PREVIEW_TYPE.NEWS_FEED:
            case META_AD_PREVIEW_TYPE.NEWS_FEED_DESKTOP:
            case META_AD_PREVIEW_TYPE.NEWS_FEED_VIDEO:
            case META_AD_PREVIEW_TYPE.NEWS_FEED_TAB:
            case META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_VIDEO_MOBILE:
            case META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_VIDEO_DESKTOP:
            case META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_BANNER_MOBILE:
            case META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_BANNER_DESKTOP:
            case META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_FULL_VIDEO:
            case META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_FULL_BANNER:
                if (masterTemplate.width < width) {
                    height = masterTemplate.height;
                }

                break;

            default:
                break;
        }

        return { adScalingFactor, width, height, maxHeight, minHeight };
    });

    return {
        adPreviewType,
        inStreamVideoIsPlaying,
        previewAdInputSize,
        setInStreamValue
    };
}
